import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SingleCoin, CoinPrice } from "../config/api";
import { CurrencyState } from "../Context";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { LinearProgress } from "@mui/material";


function Buy() {

    const { id } = useParams();
    const [coin, setCoin] = useState();
    const { currency, symbol, amountBasedOnDollar, flag, cashBalance } = CurrencyState();

    const fetchCoin = async () => {
        const { data } = await axios.get(SingleCoin(id));
        setCoin(data);
    };

    useEffect(() => {
        fetchCoin();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, currency]);


    if (!coin) return <LinearProgress style={{ backgroundColor: "var(--primary)" }} />;

    document.title = "Buy " + coin.name;

    //Calculate the number of coins a user will get for a certain amount
    const AssetPrice = coin.market_data.current_price[currency.toLowerCase()];
    const UserInput = 0.00;
    const UserInputAmountConversion = amountBasedOnDollar * UserInput;
    const TotalUserSpend = UserInputAmountConversion / AssetPrice; //Need to fix this

    //Calculate Currency Based on the state change
    const CashValueInLocalCurrency = amountBasedOnDollar * cashBalance;

    return (
        <>
            <Box><br />

                <BackButton>
                    <Link to="/Portfolio"><button><i className="fa-solid fa-arrow-left"></i> Back</button></Link>
                </BackButton>

                <h3>
                    How much would you like to spend?
                </h3>

                <center>
                    <InputForm>

                        <form>
                            <select disabled>
                                <option>{currency}</option>
                            </select>
                            <input name="amount" type="number" placeholder="Amount" />
                            <h4>{coin.symbol}: {TotalUserSpend.toFixed(6)}</h4>

                            <Notice>
                                <img src={flag} alt="" />
                                <h2>Available: {symbol} {CashValueInLocalCurrency.toFixed(2)}</h2>
                            </Notice>

                            <button type='submit'>Next</button>

                        </form>

                    </InputForm>

                </center>
                <br />

            </Box>
        </>
    )
}

export default Buy

const Box = styled.div`

    background-color: #fff;
    width: 60%;
    height: auto;
    box-shadow: rgba(99, 99, 99, 0.4) 0px 2px 8px 0px;
    margin: 0 auto;
    margin-top: 100px;
    margin-bottom: 100px;
    text-align: center;

    h3 {
        margin: 10px 0;
        font-weight: 800;
        font-size: 24px;
        text-transform: uppercase;
    }

    @media (max-width: 900px) {
        width: 95%;

        h3 {   
            font-size: 16px;
        }

        span {
            font-size: 10.5px;
        }

    }

`

const Notice = styled.div`
    display: flex;
    width: 60%;
    height: 90px;
    background-color: #efeded;
    justify-content: left;
    align-items: center;
    border-radius: 5px;
    margin: 10px 10px;
 
    h2 {
        margin-left: 10px;
        color: #333;
        font-size: 16px;
        text-align: left;
        line-height: 1.5;
        font-weight: 600;
        text-transform: uppercase;
    }

    img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-left: 15px;
    }


    @media (max-width: 900px) {
        width: 90%;
        margin: 10px 2px;
        
        h2 {
            font-weight: 600;
            font-size: 14px;
        }

        img {
            width: 40px;
            height: 40px;
            margin-left: 10px;
        }
    }

`

const InputForm = styled.div`

margin-top: 20px;

    input {
        width: 50%;
        height: 50px;
        border: 2px solid var(--primary);
        outline: none;
        padding-left: 20px;
    }

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
    margin: 0;
    }

    select {
        width: 10%;
        height: 50px;
        border: 2px solid var(--primary);
        outline: none;
        text-align: center;
        font-weight: bold;
        margin-right: 5px;
        -webkit-appearance: none;
        -moz-appearance: none;
        text-transform: uppercase;
        background-color: var(--primary);
        color: #fff;
    }

    button {
        width: 200px;
        height: 50px;
        margin-top: 5px;
        text-transform: uppercase;
        background-color: var(--primary);
        border: none;
        color: #fff;
        box-shadow: inset -2px -2px 5px rgba(255, 255, 255, 0.1), inset 2px 2px 5px rgba(0, 0, 0, 0.1);
        border-radius: 10px;
        font-weight: 700;
        font-size: 17px;

        :hover {
            background-color: transparent;
            color: var(--primary);
            border: 2px solid var(--primary);
            transition: 0.3s ease-in;
            box-shadow: rgb(0 0 0 / 15%) 0px 8px 24px;
        }
    }

    h4 {
        color: #333;
        text-transform: uppercase;
        font-size: 14px;
        margin-top: 10px;
    }

    @media (max-width: 900px) {

        input {
            width: 70%;
            height: 50px;
            border: 2px solid var(--primary);
            outline: none;
            padding-left: 20px;
        }

        select {
            width: 20%;
            height: 50px;
            border: 2px solid var(--primary);
            outline: none;
            padding-left: 10px;
            font-weight: bold;
            margin-right: 5px;
        }

    }

`

const BackButton = styled.div`

    button {
        width: 60px;
        height: 30px;
        border: none;
        font-size: 11px;
        background-color: transparent;
        text-align: center;
        font-weight: 700;
        color: #333;

        :hover {
            background-color: rgb(17, 140, 79, 0.3);
            border: none;
            transition: 0.3s ease-in;
        }
    }

`